var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"ma-0 text-wrap",class:{ 'subsecondary--text': _vm.isSecondaryText },domProps:{"innerHTML":_vm._s(_vm.contentToHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }